<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 15.09 20.11">
	<path d="M18.74,2.63H8A2.22,2.22,0,0,0,5.85,4.82V20.56A2.19,2.19,0,0,0,8,22.74H18.75a2.19,2.19,0,0,0,2.19-2.18V4.82A2.21,2.21,
	0,0,0,18.74,2.63Zm.7,17.93a.67.67,0,0,1-.2.48.65.65,0,0,1-.48.21H8a.69.69,0,0,1-.69-.69V4.82A.69.69,0,0,1,8,4.13H18.75a.69.69,
	0,0,1,.69.67Z" transform="translate(-5.85 -2.63)"/>
	<path d="M18.75,4.13H8a.69.69,0,0,0-.69.69V20.56a.69.69,0,0,0,.69.69H18.76a.65.65,0,0,0,.48-.21.67.67,0,0,0,.2-.48V4.8A.69.69,
	0,0,0,18.75,4.13ZM15.87,19.45H10.93a.73.73,0,0,1-.5-.27A.75.75,0,0,1,10.92,18h4.95a.75.75,0,0,1,0,1.5Z" 
	transform="translate(-5.85 -2.63)" fill="#fff"/>
	<path d="M16.61,18.7a.75.75,0,0,1-.74.75H10.93a.73.73,0,0,1-.5-.27A.75.75,0,0,1,10.92,18h4.95A.75.75,0,0,1,16.61,18.7Z" 
	transform="translate(-5.85 -2.63)"/>
</svg>